<div class="bg-white flex flex-nowrap">
	<ui-button
		[icon]="currentMode() ? leftSide()!.name : rightSide()!.name"
		type="link-dark"
		[disabled]="disableIcon()"
		[tabindex]="disableIcon() ? -1 : 0"
		(buttonClicked)="toggle(!currentMode())"
	>
	</ui-button>
</div>
